export default __webpack_public_path__ + "static/media/ic_red_gift@3x.43f6ed6a.png";